<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">
              Chi tiết tin tức
            </h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <el-form
              :model="mData.dataForm"
              :rules="mData.validForm"
              @submit.native.prevent
              ref="formAddNews"
              label-width="160px"
              label-position="top"
            >
              <b-row class="mb-1">
                <b-col md="2" class="pl-0">
                  <el-form-item
                    label="Ảnh bài viết"
                    prop="image"
                    class="time-attendance-photo"
                    ref="image"
                  >
                    <el-image
                      v-if="!loadImage"
                      class="avatar__image"
                      @click="
                        showDetailImage(imgUrl ? imgUrl : 'img/document.jpg')
                      "
                      :src="imgUrl
                            ? imgUrl
                            : 'img/document.jpg'
                      "
                      fit="cover"
                      title="Nhấn vào để xem trước"
                    ></el-image>
                  </el-form-item>
                </b-col>

                <b-col md="10" class="p-0">
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Danh mục tin tức" prop="category_id">
                        <el-select
                          v-model="mData.dataForm.category_id"
                          filterable
                          disabled
                        >
                          <el-option
                            v-for="item in listNewsCategory"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Nổi bật" prop="is_important">
                        <el-select
                          v-model="mData.dataForm.is_important"
                          filterable
                          @input="forceUpdateUI"
                          disabled
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listOutStanding"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col
                      md="4"
                    >
                      <div class="new__status">
                          <p class="mr-2 status__block-title">Trạng thái bài viết</p>
                          <div :class="{
                            'content status__block': true,
                            waiting_approver:
                              mData.dataForm.status == 'WAITING_APPROVER',
                            request_edit: mData.dataForm.status == 'REQUEST_EDIT',
                            approver: mData.dataForm.status == 'APPROVERED',
                          }"
                          >
                            {{ NewsListModel.matchStatusName(mData.dataForm.status) }}
                          </div>
                        </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col :md="checkShowNote ? '4' : '12'">
                      <el-form-item label="Tiêu đề bài viết" prop="title">
                        <el-input
                          type="textarea"
                          v-model="mData.dataForm.title"
                          placeholder=""
                          disabled
                          resize="none"
                          :rows="3"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="8" v-if="checkShowNote">
                      <el-form-item label="Nội dung cần chỉnh sửa">
                        <p class="note-content">{{ showContent }}</p>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" class="editor_custom pl-0">
                  <el-form-item
                    label="Nội dung bài viết"
                    prop=""
                  >
                    <ckeditor
                      v-model="mData.dataForm.content"
                      :config="editorConfig"
                      :readOnly="editorConfig.readOnly"
                       editor-url="/ckeditor/ckeditor.js"
                    ></ckeditor>
                  </el-form-item>
                </b-col>
              </b-row>
              <div class="text-center mt-3">
                <el-button
                  round
                  class="btn-back"
                  @click="fn_goToNewsList()"
                >
                  Quay lại
                </el-button>
                <el-button
                  v-if="checkShowButtonApprove"
                  type="warning"
                  @click="openDialogNote"
                >
                  Yêu cầu chỉnh sửa
                </el-button>
                <el-button
                  v-if="checkShowButtonApprove"
                  type="success"
                  @click="fn_publishNews"
                >
                  Duyệt
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <el-image-viewer
      class="dialog__image-viewer"
      v-if="visibleDialogImage"
      :on-close="closeViewer"
      :url-list="[imgUrl]"
    />
    <el-dialog
      title="Nội dung cần chỉnh sửa"
      :visible.sync="noteDialogVisible"
      :before-close="beforeCloseNoteDialog"
    >
      <div>
        <el-form
          ref="noteForm"
          :model="noteForm"
          :rules="validNoteForm"
          label-width="80px"
          label-position="top"
        >
          <el-form-item label="Nội dung cần chỉnh sửa" prop="content">
          <el-input
            type="textarea"
            v-model="noteForm.content"
            maxlength="500"
            show-word-limit
            resize="none"
            :autosize="{
              minRows: 3,
              maxRows: 5,
            }"
            @change="noteForm.content = noteForm.content.trim()"
          ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button
          @click="beforeCloseNoteDialog"
        >
          Đóng
        </el-button>
        <el-button
          type="warning"
          @click="fn_requestEditNew"
        >
          Yêu cầu chỉnh sửa
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../../service/LanguageService";
import ExtensionService from "../../../../service/ExtensionService";
import ValidService from "../../../../service/ValidService";
import MethodService from "../../../../service/MethodService";
import NewsApi from "../../../../moduleApi/NewsApi";
import NewsCategoryApi from "../../../../moduleApi/NewsCategoryApi";
import NewsListModel from "./NewsListModel";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      NewsListModel,
      editorConfig: {
        height: 300,
        readOnly: true,
        editorplaceholder: "Nhập nội dung ở đây...",
        extraPlugins: "colorbutton,colordialog,justify,editorplaceholder",
        removeButtons: 'Save,Print,NewPage',
        // The configuration of the editor.
        toolbarGroups: [
          { name: "clipboard", groups: ["undo"] },
          { name: "editing", groups: ["find", "selection", "spellchecker"] },
          { name: "links" },
          { name: "insert" },
          { name: "forms" },
          { name: "tools" },
          { name: "document", groups: ["mode", "document", "doctools"] },
          { name: "others" },
          { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
          },
          { name: "styles" },
          { name: "colors" },
          { name: "about" },
        ],
      },
      mData: {
        id: null,
        moduleName: "News", //required
        dataForm: MethodService.copyObject(NewsListModel.dataForm),
        validForm: NewsListModel.validForm,
        tableRules: MethodService.copyObject(NewsListModel.tableRules),
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listOutStanding: NewsListModel.listOutStanding,
          listNewsStatus: NewsListModel.listNewsStatus,
        },
        currentUser: MethodService.getCurrentUser(),
        currentCompany: MethodService.getCompanyInfo(),
        companyInfo: {},

        fileUploadOption: {
          dialogImageUrl: "",
          dialogVisible: false,
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
      noteDialogVisible: false,
      noteForm: {
        user_id: MethodService.getCurrentUser().id,
        request_date: new Date().toISOString(),
        content: undefined,
      },
      validNoteForm: {
        content: [ValidService.required]
      },
      imgUrl: "",
      loadImage: false,
      visibleDialogImage: false,
      listNewsCategory: [],
      isCreator: false,
    };
  },
  computed: {
    checkShowButtonApprove() {
      return this.mData.dataDefault.listFeature.includes('FT2203') && this.mData.dataForm.status == 'WAITING_APPROVER'
    },
    checkShowNote() {
      return this.mData.dataForm.status != 'APPROVERED' && this.mData.dataForm.notes.length > 0
    },
    showContent() {
      return this.mData.dataForm.notes[this.mData.dataForm.notes.length - 1].content
    }
  },
  methods: {
    fn_checkValid() {
      if (this.mData.dataForm.content) this.$refs["formAddNews"].clearValidate("content");
      else this.$refs["formAddNews"].validateField("content");
    },
    async fn_getListNewsCategory() {
      const newsCategoryApiRes = await NewsCategoryApi.list({
        limit: 9999,
      });
      if (newsCategoryApiRes.result) {
        this.listNewsCategory = newsCategoryApiRes.result;
      }
    },

    showDetailImage(url) {
      this.imgUrl = url;
      setTimeout(() => {
        this.visibleDialogImage = true;
      }, 100);
    },

    closeViewer() {
      this.visibleDialogImage = false;
    },

    beforeCloseDialogImage() {
      this.imgUrl = "";
      this.visibleDialogImage = false;
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      resData.forEach((item) => {
        if (item.category_id) {
          const category = this.listNewsCategory.find(
            (o) => o.id == item.category_id
          );
          item.category_name = category ? category.name : "";
        }
        if (item.creator_id) {
          const person = this.listNewsCategory.find(
            (o) => o.id == item.creator_id
          );
          item.creator_name = person
            ? person.name
            : item.creator_id == this.mData.currentCompany.id
            ? this.mData.currentCompany.name.name_vi
            : "";
        }
        item.status_name =
          item.status == "WAITING_APPROVER"
            ? "Chờ duyệt"
            : item.status == "REQUEST_EDIT"
            ? "Yêu cầu chỉnh sửa"
            : item.status == "APPROVERED"
            ? "Đã duyệt"
            : "";
      });
      return resData;
    },

    async fn_getDataById(id) {
      let res = await NewsApi.findById(id);
      if (res.result) {
        if (!res.result.notes) res.result.notes = []
        this.mData.dataForm = res.result
        console.log('this.mData.dataForm', this.mData.dataForm);
        this.imgUrl = ExtensionService.urlImg + res.result.image
      }
    },
    async fn_checkStatusNew() {
      let res = await NewsApi.findById(this.$route.params.id);
      if (res.result && res.result.status === "APPROVERED") this.isApproved = true
    },
    async fn_publishNews() {
      try {
        await this.fn_checkStatusNew()
        if (this.isApproved) {
          window.toastr.warning(
            "Tin tức này đã được duyệt. Bạn không thể thao tác trên tin tức này nữa."
          );
          setTimeout(() => {
            this.fn_goToNewsList();
          }, 3500);
          return;
        }
        await NewsApi.ApproveNews(this.$route.params.id);
        window.toastr.success("Duyệt tin thành công");
        await this.fn_goToNewsList();
      } catch (error) {
        if (error && error.code && error.code === 500) {
          window.toastr.error(error.detail);
        } else {
          window.toastr.error("Duyệt tin thất bại");
        }
      }
    },
    fn_requestEditNew() {
      this.$refs["noteForm"].validate(async (valid) => {
        if (!valid) return
        try {
          await this.fn_checkStatusNew();
          if (this.isApproved) {
            window.toastr.warning(
              "Tin tức này đã được duyệt. Bạn không thể thao tác trên tin tức này nữa."
            );
            this.beforeCloseNoteDialog()
            setTimeout(() => {
              this.fn_goToNewsList()
            }, 3500);
            return;
          }
          this.mData.dataForm.notes.push(this.noteForm)
          const dataUpdate = {
            id: this.$route.params.id,
            status: "REQUEST_EDIT",
            notes: this.mData.dataForm.notes,
          }
          await NewsApi.update(dataUpdate);
          window.toastr.success("Yêu cầu chỉnh sửa tin thành công");
          this.beforeCloseNoteDialog()
          await this.fn_goToNewsList();
        } catch (error) {
          window.toastr.error("Yêu cầu chỉnh sửa tin thất bại");
        }
      })
    },
    openDialogNote() {
      this.noteDialogVisible = true
    },
    beforeCloseNoteDialog() {
      this.$refs['noteForm'].clearValidate()
      this.noteDialogVisible = false
      this.noteForm = {
        user_id: undefined,
        request_date: undefined,
        content: undefined,
      }
    },
    fn_goToNewsList() {
      this.$router.go(-1)
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
  },

  //run after render view
  async created() {
    this.mData.validForm.image = [ValidService.requiredChange];
    await this.fn_getDataById(this.$route.params.id);
    await this.fn_getListNewsCategory();
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: all 0.2s ease;
}
.note-content {
  padding: 8px;
  background: #f4f4f5;
  border-radius: 8px;
  color: #4e5055;
  font-size: 14px;
  height: 90px;
  overflow: auto;
}
.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.icon {
  cursor: pointer;
}
::v-deep .isax-setting-2 {
  transition: 0.2s ease;
  &:hover {
    color: var(--orange);
  }
}
::v-deep .el-input-number {
  .el-input__inner {
    text-align: left;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    border: none;
    background: transparent;
    line-height: 20px !important;
  }
}
::v-deep .content {
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .time-attendance-photo {
  margin-bottom: 15px;
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
.upload-demo {
  width: fit-content;
  margin: 0 auto;
  margin-top: 10px !important;
}
.upload-demo .el-upload .el-button {
  padding: 5px 23px;
  border-radius: 5px !important;
}
.avatar__image {
  max-width: 100%;
  height: 120px;
  left: 50%;
  transform: translateX(-50%);
  :hover {
    cursor: pointer;
  }
}
.icon24-Stamp {
  font-size: inherit;
}

::v-deep .editor_custom {
  .ql-editor {
    background-color: #fff;
  }
  .ql-picker {
    margin-top: -11px;
  }
  .ql-color-picker,
  .ql-align {
    margin-top: -15px;
  }
  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    margin-top: -3px;
  }
}
.cursor-notAllow {
  cursor: not-allowed !important;
}
::v-deep .hide-toolbar {
  .ql-toolbar {
    padding: 0;
    border-bottom: hidden;
    span {
      display: none;
    }
  }
  .ql-editor {
    cursor: not-allowed;
  }
}
.new__status {
  font-size: 15px;
  .status__block-title {
    font-size: 15px;
    margin-bottom: 13px;
  }
  .status__block {
    font-family: 'UTM Avo';
    width: fit-content;
    padding: 10px 15px;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgb(0, 0, 0, 0.1);
  }
  .waiting_approver {
    color: #3db82b;
    background: #cef1c2;
  }
  .request_edit {
    color: #ff8800;
    background: #ffc31d4b;
  }
  .approver {
    color: white;
    background: #6bc457;
  }
}
</style>
<style>
.cke_notification_warning {
  display: none !important;
}
</style>